import React from 'react';
import './rating.less';

export default class Rating extends React.Component{
    constructor(props){
        super(props);
        this.createRating = this.createRating.bind(this);
    }
    createRating(className, index, styles){
        var star = [];
        let i=0;
        for(i=0; i<index; i++){
            star.push(<span className={className} style={styles}></span>)
        }
        return star;
    }
    render(){
        const toatlRating = 5;
        const {props} = this;
        let rating;
        let ratingSize;
        props.ratingSize ? ratingSize = props.ratingSize : ratingSize = 'rating-size12';
        let filledIconClasses = 'icon-star-filled' + ' ' + ratingSize;
        let filledEmptyClasses = 'icon-star-unfilled' + ' ' +  ratingSize;

        if(props.rating < 0){
            rating = 0;
        }
        else{
            props.rating > 5 ? rating = 5 : rating  = props.rating;
        }

        rating = Math.round(rating);

        let ratedStar;
        let unratedStar;
        (rating > 0) ? ratedStar = this.createRating(filledIconClasses, rating) : ratedStar=[];
        (toatlRating-rating > 0) ? unratedStar = this.createRating(filledEmptyClasses, toatlRating - rating) : unratedStar=[];
        let totalRating = [];
        totalRating.push(ratedStar);
        totalRating.push(unratedStar);

        return(
            <span>{totalRating}</span>
        )
    }
}

// Rating.propTypes = {
//     rating: React.PropTypes.number.isRequired,
//     ratingSize: React.PropTypes.string
// }
// Rating size is optional



// WEBPACK FOOTER //
// app/components/rating/rating.jsx